import { render, staticRenderFns } from "./ManageLayout.vue?vue&type=template&id=80a367f8&scoped=true&"
import script from "./ManageLayout.vue?vue&type=script&lang=js&"
export * from "./ManageLayout.vue?vue&type=script&lang=js&"
import style0 from "./ManageLayout.vue?vue&type=style&index=0&id=80a367f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a367f8",
  null
  
)

export default component.exports